<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="20"
      height="20"
      rx="5"
      fill="#A0A0A0"
    />
    <path
      d="M8.75 6.25L12.5 10L8.75 13.75"
      stroke="#FFFFFF"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<style lang="scss" scoped>
svg rect:hover {
  fill: #3B82F6;
}
</style>
